import { BaseService } from '../../infra/base.service'
import type { CepCoordinate, CustomerLocations } from './customer-location.entity'
import type { CepGeoRepository, GeoRepository } from './geo.repository'

export class GeoService extends BaseService<CustomerLocations> {
    constructor(
        private rep: GeoRepository,
        private cepRep: CepGeoRepository,
    ) {
        super(rep)
    }

    // Sem cache de propósito: a consulta é um SELECT indexado, e cachear faria a tela ignorar
    // um endereço que o usuário acabou de corrigir no cadastro.
    async getCustomers(limit: number = 1000): Promise<CustomerLocations> {
        return await this.rep.getAll({ limit })
    }

    // Amostra a partir de uma lista de pessoas, na ordem em que ela vem — hoje, os compradores
    // ordenados pela última compra.
    //
    // Lista vazia NÃO cai no getCustomers: sem venda no período a resposta correta é um mapa
    // vazio, com a tela explicando o porquê. Cair no padrão traria de volta os cadastros sem
    // compra, que é o que esta tela deixou de mostrar.
    async getCustomersByIds(personIds: string[], limit: number = 1000): Promise<CustomerLocations> {
        return await this.rep.getByPersonIds(personIds || [], limit)
    }

    // Coordenada de um CEP avulso — a tela usa para plotar a própria unidade.
    // Devolve null quando o CEP não está na tabela, em vez de estourar: não ter o ponto da
    // unidade é um caso previsto, não um erro.
    async getCep(cep: string): Promise<CepCoordinate> {
        const digitos = (cep || '').replace(/\D/g, '')
        if (digitos.length !== 8) return null
        try {
            return await this.cepRep.getOne(digitos)
        } catch (error) {
            return null
        }
    }
}
